"use strict";

var _classCallCheck = require("/tmp/travis-listener/essote-henkilotietolomake/master/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Helper class for evaluating "visible if" rules
 */

var VisibileIfEvaluator = function VisibileIfEvaluator() {
  _classCallCheck(this, VisibileIfEvaluator);
};
/**
 * Evaluates given visible if rule
 *
 * @param visibleIf rule
 * @param getFieldValue method for retrieving form values
 * @returns whether rule evaluated as visible or hidden
 */


VisibileIfEvaluator.isVisible = function (visibleIf, getFieldValue) {
  if (!visibleIf) {
    return true;
  }

  var result = false;
  var field = visibleIf.field;

  if (field && visibleIf.equals) {
    result = visibleIf.equals === getFieldValue(field);
  }

  if (!result && field && visibleIf.notEquals) {
    result = visibleIf.equals !== getFieldValue(field);
  }

  var ands = visibleIf.and || [];

  for (var i = 0; i < ands.length; i++) {
    if (!VisibileIfEvaluator.isVisible(ands[i], getFieldValue)) {
      return false;
    }
  }

  if (!result) {
    var ors = visibleIf.or || [];

    for (var _i = 0; _i < ors.length; _i++) {
      if (VisibileIfEvaluator.isVisible(ors[_i], getFieldValue)) {
        return true;
      }
    }
  }

  return result;
};

exports.default = VisibileIfEvaluator;